import { getLocalhostImage } from "./imagesModules";

export function convertHTML(html) {
  // 1. 移除 <p> 标签
  html = html.replace(/<p[^>]*>/g, "").replace(/<\/p>/g, "");

  // 2. 移除 <span> 标签
  html = html.replace(/<span[^>]*>/g, "").replace(/<\/span>/g, "");

  // 3. 移除 &nbsp;
  html = html.replace(/&nbsp;/g, "");

  // 4. 移除内联样式
  // html = html.replace(/ style="[^"]*"/g, "");

  // 5. 转义 &gt; 和 &lt;
  html = html.replace(/&gt;/g, ">").replace(/&lt;/g, "<");

  return html;
}
//本地图片获取
export function getImageUrls(name) {
	//let path = new URL(name, import.meta.url).href,
	//let path = (import.meta.env.MODE == 'development' ? '/src':'') + `/assets/images/${name}`;
	 //new URL(name, import.meta.url).href;
  return getLocalhostImage(name);
}
  export function getImageUrl(name) {
    return `/images/${name}`;
  }
export function apiImgUrl(url) {
  return import.meta.env.VITE_IMAGE_URL + url;
}
/**
 * @description 获取当前设计 移动端/PC端
 * @param
 * @return true= 移动端 false= Pc端
 */
export function checkDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (
    /windows phone/i.test(userAgent) ||
    /iphone|iPhone|ipad|iPad|ipod|iPod/.test(userAgent) ||
    /android|Android/i.test(userAgent)
    //|| /firefox/i.test(userAgent)
    //|| /chrome/i.test(userAgent)
    //|| /uc/i.test(userAgent)
  ) {
    return true;
  } else {
    return false;
  }
}

export const getDictItem = (list: any[], item: any, type: string) => {
  if (list && list.length > 0) {
    const res = list.find(
      (i) => i[type == "status" ? "dictType" : "dictValue"] == item
    );
    if (res) {
      return res.dictLabel;
    }
    return "";
  }
  return "";
};

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) {
    return `${bytes} B`;
  } else if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(2)} KB`; // 保留2位小数
  } else {
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }
};
